import { RouteProps } from "react-router";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import * as actions from "src/bepaid/store/model/Fetch/actions";

import Component from "./View";

const mapStateToProps = (state: RootState) => ({
  currencySymbol: selectors.getCurrentCurrencySymbol(state),
  payInsights: selectors.getPayInsights(state),
  hasToken: selectors.hasToken(state)
});

const mapDispatchToProps = {
  getPayInsights: actions.getPayInsights
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Component);
